export const CONSENT_VERSION = "1" as const;

export interface ConsentData {
  version: typeof CONSENT_VERSION;
  analytics: boolean;
  savedAt: number;
}

export function getStoredConsent(key: string): ConsentData | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ConsentData>;
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed as ConsentData;
  } catch {
    return null;
  }
}

export function saveConsent(key: string, analytics: boolean): ConsentData {
  const data: ConsentData = { version: CONSENT_VERSION, analytics, savedAt: Date.now() };
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(data));
    window.dispatchEvent(new CustomEvent("consentchange", { detail: data }));
  }
  return data;
}
